export enum LocationLevel {
	Country = "Country",
	CountryPart = "CountryPart",
	Region = "Region",
	District = "District",
	Town = "Town",
	TownPart = "TownPart",
}
